import React, { useState } from 'react';
import './recuperarContrasena.css';

const RecuperarContrasena = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      // Aquí iría la lógica de Firebase para recuperar contraseña
      /*
      await sendPasswordResetEmail(auth, email);
      */
      
      // Simulación de envío exitoso

      setSuccess(true);
      
    } catch (error) {
      // Manejo de errores de Firebase comentado
      /*
      switch (error.code) {
        case 'auth/invalid-email':
          setError('El correo electrónico no es válido');
          break;
        case 'auth/user-not-found':
          setError('No existe una cuenta con este correo electrónico');
          break;
        default:
          setError('Error al enviar el correo de recuperación');
      }
      */
      setError('Error al enviar el correo de recuperación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="recuperar-container">
      <div className="recuperar-box">
        <h2>Recuperar Contraseña</h2>
        <p className="recuperar-descripcion">
          Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
        </p>

        {error && <div className="error-message">{error}</div>}
        {success && (
          <div className="success-message">
            Se ha enviado un correo electrónico con las instrucciones para recuperar tu contraseña.
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Correo Electrónico</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="ejemplo@correo.com"
            />
          </div>
          <button 
            type="submit" 
            className="recuperar-button"
            disabled={loading}
          >
            {loading ? 'Enviando...' : 'Enviar Correo de Recuperación'}
          </button>
        </form>

        <div className="recuperar-footer">
          <p className="login-link">
            ¿Recordaste tu contraseña? <a href="/iniciosesion">Iniciar Sesión</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RecuperarContrasena; 